import { FC } from "react";

import { ThemeProvider } from "@mui/material";
import Box from "@mui/material/Box";

import { NewsletterFormEmbeddedPageLayout } from "../sharedComponents/NewsletterFormEmbeddedPageLayout";
import { NewsletterFormPageLayout } from "../sharedComponents/NewsletterFormPageLayout";
import { NewsletterFormSignUp } from "../sharedComponents/NewsletterFormSignUp";

// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- legacy cross-layer import (pre-rule); migrate when touched
import { OrganizationLogoAndName } from "@/canvas/components/OrganizationLogoAndName/OrganizationLogoAndName";
import { AmplitudeEvents } from "@/common/constants/amplitude";
import { useLogVisitPageAmplitudeEvent } from "@/common/hooks/amplitude/useLogVisitPageAmplitudeEvent";
import { NewsletterFormFrontendPageOutput } from "@/common/types/trpc";
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- legacy cross-layer import (pre-rule); migrate when touched
import { useDynamicCanvasTheme } from "@/forms-design-system/Tokens/dynamicCanvasTheme";

export const NewsletterFormContainer: FC<{
  newsletterForm: NewsletterFormFrontendPageOutput;
  isEmbedded?: boolean;
}> = ({ newsletterForm, isEmbedded }) => {
  useLogVisitPageAmplitudeEvent({
    event: AmplitudeEvents.SignupFormVisited,
    payload: {
      organizationId: newsletterForm.organization.id,
      formId: newsletterForm.id,
      formPath: newsletterForm.path,
      isEmbedded,
    },
  });

  const themeV2 = useDynamicCanvasTheme(newsletterForm.buttonColor, "light");

  if (isEmbedded) {
    return (
      <NewsletterFormEmbeddedPageLayout>
        <NewsletterFormSignUp newsletterForm={newsletterForm} isEmbedded />
      </NewsletterFormEmbeddedPageLayout>
    );
  }

  return (
    <NewsletterFormPageLayout
      backgroundColor={newsletterForm.buttonColor}
      slots={{
        organizationBanner: (
          <Box>
            <ThemeProvider theme={themeV2}>
              <OrganizationLogoAndName
                name={newsletterForm.organization.name}
                logoSrc={newsletterForm.organization.logoUrl ?? undefined}
              />
            </ThemeProvider>
          </Box>
        ),
        form: (
          <ThemeProvider theme={themeV2}>
            <NewsletterFormSignUp newsletterForm={newsletterForm} />
          </ThemeProvider>
        ),
      }}
    />
  );
};
